import { render } from "./ItemSettings.vue?vue&type=template&id=7f0bdb4a"
import script from "./ItemSettings.vue?vue&type=script&lang=js"
export * from "./ItemSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__